export const SERVER_URL = "https://moveapi-test.wsd.com.mx/api"